/**
 * Keeps every cart count / cart total badge on the page (desktop header,
 * mobile header, mobile bottom nav) in sync with the real Shopify cart.
 * Dawn's own cart scripts (cart.js, product-form.js, cart-drawer.js, ...)
 * all publish PUB_SUB_EVENTS.cartUpdate whenever the cart changes, so we
 * just listen for that and refresh every [data-hl-cart-count] /
 * [data-hl-cart-total] element via the cart's JSON endpoint.
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.hlMoneyFormat || '{{amount}}');

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function refreshBadges() {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-hl-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-hl-cart-total]').forEach(function (el) {
          el.textContent = formatMoney(cart.total_price);
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function flashCartIcon() {
    document.querySelectorAll('.hl-cart-link').forEach(function (el) {
      if (typeof el.animate !== 'function') return;
      el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], {
        duration: 320,
        easing: 'ease-out',
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshBadges();
        flashCartIcon();
      });
    }
  });
})();
